import { render } from "./sales-order-settings.vue?vue&type=template&id=6865cb42"
import script from "./sales-order-settings.vue?vue&type=script&lang=js"
export * from "./sales-order-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__